import React from 'react';
import {
  StyledHeaderBar,
  StyledHeaderBarContainer,
  StyledHeaderBarTitle,
  StyledHeaderSearchBox,
  StyledHeaderBarLinksBox,
  StyledHeaderBarLink
} from './HeaderBar.style';
import { ContentBox, DarkModeSwitch, FlexBox, SearchField, SideMenuSwitch } from '../';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

const HeaderBar = ({ headerLinks, hasSideBar, hasSearch, children }) => {
  return (
    <StyledHeaderBar>
      <ContentBox>
        <StyledHeaderBarContainer>
          <Link className="hideOnMobile" to="/">
            <StaticImage
              formats={['auto', 'webp', 'avif', 'svg']}
              src="../../../static/rlm_logo.svg"
              alt="Logo"
              height={40}
            />
            <StyledHeaderBarTitle>Rafael López Martínez</StyledHeaderBarTitle>
          </Link>
          {hasSearch && 
            (<StyledHeaderSearchBox>
              <SearchField />
            </StyledHeaderSearchBox>)
          }
          <StyledHeaderBarLinksBox>
            <FlexBox flexDirection="row">
              <Link className="showOnMobileOnly" key="home" to="/">
                <StyledHeaderBarLink>Home</StyledHeaderBarLink>
              </Link>
              {headerLinks.map((link) => (
                <Link key={link.text} to={link.to}>
                  <StyledHeaderBarLink>{link.text}</StyledHeaderBarLink>
                </Link>
              ))}
            </FlexBox>
            <DarkModeSwitch />
            <SideMenuSwitch visible={hasSideBar || false} />
          </StyledHeaderBarLinksBox>
        </StyledHeaderBarContainer>
      </ContentBox>
    </StyledHeaderBar>
  );
};

export default HeaderBar;
